import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a> <i className='glyphicon glyphicon-toright'></i> <span>朋友圈广告</span>
				</div>
				<div className='home-contain' style={{padding: '0 108px 50px 108px'}}>
					<div className='group--left' style={{paddingTop: '115px'}}>
						<div>
							<div className='text-center' style={{position: 'relative'}}>
								<img className='block-center' src={`${process.env.PUBLIC_URL}/images/pyq.png`} />
							</div>
						</div>
						<div className='common-title' style={{marginBottom: '24px'}}>推广故事</div>
					</div>
					<div className='group--right'>
						<div className='text-contain' style={{padding:  '50px 0 0 0'}}>
							<span className='special'>文案:</span>
							<span>贴近生活，添加优惠信息更能吸引用户点击</span>
							<span className='special'>详情页：</span>
							<span>标题与描述阐述具体活动内容，直接引导用户填写信息，更能促成转化</span>
							<span className='special'>优化：</span>
							<span>做A/B test测试，根据数据反馈， 重新组合定向、素材、详情页投放</span>
							<span className='special'>跟踪：</span>
							<span>每日进行数据统计与分析，对比不同投放方案的效果差距，及时调整投放方案</span>
							<span className='special'>效果数据：</span>
							<span className='special'>CTR：提高3%-6%</span>
							<span className='special'>客资成本：50元-80元/个</span>
							<span>转化成本：140-180元/元</span>
							<span className='special'>投放总结：</span>
							<span className='special'>客资成本和转化成本均低于广告主的期望值；</span>
							<span className='special'>LBS精准定向、单次小金额投放很好满足了该广告主投放需求；</span>
							<span>广告主预计下次活动增加2倍预算投放。</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/examples/pyq.jsx